import { SideBar, FloatingCreateButton } from "components";
import { useLocation } from "react-router-dom";

type Props = {
    children: React.ReactNode;
};
export default function ContentLayout({ children }: Props) {
    const location = useLocation();
    const isLoggedIn = !!localStorage.getItem("user_access_token") && !!localStorage.getItem("terms_agree");
    const isLandingPage = location.pathname === "/" && !isLoggedIn;

    // Only the landing page uses full-width layout
    const isWide = isLandingPage;

    return (
        <div className="flex flex-col min-h-screen">
            {/* ─── Global Top Navigation ─── */}
            <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-achromatic-100/60 mobile:hidden">
                <div className="max-w-[860px] w-full mx-auto px-6">
                    <SideBar />
                </div>
            </header>

            {/* ─── Main Content ─── */}
            <main
                className={
                    isWide
                        ? "flex-1 w-full mobile:pb-20"
                        : "flex-1 max-w-[860px] w-full mx-auto px-6 py-6 mobile:px-4 mobile:pt-4 mobile:pb-20 mobile:max-w-none"
                }
            >
                {children}
            </main>

            {/* ─── Global Footer ─── */}
            {!isWide && (
                <footer className="max-w-[860px] w-full mx-auto px-6 py-6 mobile:px-4 mobile:pb-24">
                    <div className="border-t border-achromatic-100 pt-5">
                        <div className="text-[10px] text-achromatic-300 leading-[1.8]">
                            <p>주식회사 젤리펀치 | 대표: 송창환 | 사업자등록번호: 807-81-00467</p>
                            <p>통신판매업: 2022-서울강남-01300 | 주소: 서울시 강남구 테헤란로79길 6, 4층 브이 590호</p>
                            <p>전화: 0502-6681-2043 | 문의: help@jellypunch.com</p>
                            <p className="mt-1.5 text-achromatic-400">
                                티팟(TIPOT)은 통신판매중개자이며, 통신판매의 당사자가 아닙니다. 따라서 티팟은 호스트(판매자)가
                                등록한 상품, 거래 정보 및 거래에 대하여 책임을 지지 않습니다.
                            </p>
                        </div>
                        <p className="text-[9px] text-achromatic-300 mt-3">
                            © {new Date().getFullYear()} Jellypunch Co., Ltd. All rights reserved.
                        </p>
                    </div>
                </footer>
            )}

            <FloatingCreateButton />

            {/* ─── Mobile Bottom Nav ─── */}
            <div className="hidden mobile:block fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-achromatic-100">
                <SideBar isMobile />
            </div>
        </div>
    );
}